import { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { FiUpload, FiX } from 'react-icons/fi';

interface DropZoneProps {
  onFilesAdded: (files: File[]) => void;
}

export default function AssetDropZone({ onFilesAdded }: DropZoneProps) {
  const [files, setFiles] = useState<File[]>([]);

  const onDrop = useCallback((acceptedFiles: File[]) => {
    setFiles(prev => [...prev, ...acceptedFiles]);
    onFilesAdded(acceptedFiles);
  }, [onFilesAdded]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const removeFile = (fileToRemove: File) => {
    setFiles(files.filter(file => file !== fileToRemove));
  };

  return (
    <div>
      <div
        {...getRootProps()}
        // className={`border-2 border-dashed rounded-lg p-2 text-center cursor-pointer
        //   ${isDragActive ? 'border-blue-500 bg-blue-500/10' : 'border-gray-600 hover:border-gray-500'}
        // `}
        className='flex justify-end mt-5'
      >
        <input {...getInputProps()} />
        {/* <FiUpload className="mx-auto mb-4 text-gray-400" size={24} /> */}
        <img src='/icons/upload-icon.png' className='group-hover:scale-[1] scale-[0.8] p-2 py-2 rounded-md bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] text-white hover:opacity-90 transition-all duration-300 ease-in-out cursor-pointer' />
        {/* <p className="text-gray-400">
          {isDragActive
            ? "Drop the files here..."
            : "Drag 'n' drop files here, or click to select files"
          }
        </p> */}
      </div>

      {files.length > 0 && (
        <div className="mt-4 space-y-2 h-[80px] overflow-y-auto p-2">
          {files.map((file, index) => (
            <div
              key={index}
              className="flex items-center justify-between bg-[#2A2A2A] p-2 rounded-lg"
            >
              <span className="text-gray-400">{file.name}</span>
              <button
                onClick={() => removeFile(file)}
                className="text-gray-400 hover:text-red-500"
              >
                <FiX />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
} 